module.exports = __webpack_public_path__ + "resources/img/bg_banner_tcc.147f377ba49d6168a9eca60c38b958a7.png";